import React from 'react';

const Spinner: React.FC = () => {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
};

export default Spinner;